import React from 'react';
import styled from 'styled-components';
import ScrollMotion from '@common/ScrollMotion';
import AnimatedStroke from '@common/AnimatedStroke';
import ProductImage from '@common/ProductImage';

export default ({ imgSrc, artFg, artBg, artLeft = false, caption }) => (
  <Wrapper>
    <ImageContainer>
      <ScrollMotion
        rotate={artLeft ? { start: 0, end: -4 } : { start: 0, end: 4 }}
        translate={{ start: 52, end: -24 }}
      >
        <ProductImage />
      </ScrollMotion>
      <ArtWrapper left={artLeft}>
        <AnimatedStroke svg={artFg} animProps={{ duration: 1500 }} />
        <ScrollMotion translate={{ start: 26, end: -12 }}>{artBg}</ScrollMotion>
      </ArtWrapper>
    </ImageContainer>
    <ProductCaption>{caption}</ProductCaption>
  </Wrapper>
);

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;

const ImageContainer = styled.div`
  position: relative;
  display: flex;
  justify-content: center;
`;

const Img = styled.img`
  filter: drop-shadow(12px 8px 16px rgba(0, 0, 0, 0.7));
  z-index: 1;
`;

const ProductCaption = styled.div`
  margin-top: 4rem;
  transform: rotate(-3deg);
  font-family: ${props => props.theme.font.cursive};
  color: ${props => props.theme.color.blue[1].light};
  ${props => props.theme.font_size.regular};

  @media (max-width: ${props => props.theme.screen.md}) {
    display: none;
  }
`;

const ArtWrapper = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  z-index: -1;

  > div {
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
  }
`;
